import { useEffect, useState } from 'react';
import { ClaireService } from '../../services/claireService';

const FALLBACK = '/claire-face.webp';
const STORAGE_KEY = 'claireAvatarUrl';

let current = localStorage.getItem(STORAGE_KEY) || FALLBACK;
let fetched = false;
const listeners = new Set<(url: string) => void>();

/** Updates every Claire avatar on the page (e.g. right after Master Claire saves a new one). */
export function setClaireAvatar(url: string | null) {
  current = url || FALLBACK;
  if (url) localStorage.setItem(STORAGE_KEY, url);
  else localStorage.removeItem(STORAGE_KEY);
  listeners.forEach((l) => l(current));
}

export function useClaireAvatar(): string {
  const [url, setUrl] = useState(current);
  useEffect(() => {
    listeners.add(setUrl);
    if (!fetched) {
      fetched = true;
      ClaireService.avatarUrl()
        .then(setClaireAvatar)
        .catch(() => {
          fetched = false;
        });
    }
    return () => {
      listeners.delete(setUrl);
    };
  }, []);
  return url;
}

export function onClaireAvatarError(e: React.SyntheticEvent<HTMLImageElement>) {
  if (!e.currentTarget.src.endsWith(FALLBACK)) e.currentTarget.src = FALLBACK;
}
